<div class="row page-content">
  <div class="ibox-content pos-relative">
    <app-invoices-form (onAfterSave)="afterSave()"></app-invoices-form>
  </div>
</div>
